const info = [
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'nibiru',
            client_id: '07-tendermint-2',
            connection_id: 'connection-2'
        },
        chain_2: {
            chain_name: 'noble',
            client_id: '07-tendermint-86',
            connection_id: 'connection-86'
        },
        channels: [
            {
                chain_1: {
                    channel_id: 'channel-2',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-67',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live'
                }
            }
        ]
    },
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'nibiru',
            client_id: '07-tendermint-0',
            connection_id: 'connection-0'
        },
        chain_2: {
            chain_name: 'osmosis',
            client_id: '07-tendermint-3104',
            connection_id: 'connection-2580'
        },
        channels: [
            {
                chain_1: {
                    channel_id: 'channel-0',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-21113',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live'
                }
            }
        ]
    }
];
export default info;
